import { createSelector } from '@reduxjs/toolkit'

import { getLoan } from '../root.selectors'
import { RootState } from '../root.reducer'

export const isStopAccuralsLoading = createSelector([getLoan], (loan) => loan.stopAccruals.pending === 'loading')
export const stopAccrualsPending = (state: RootState) => getLoan(state).stopAccruals.status === 'loading'

export const isUndoStopAccuralsLoading = createSelector(
  [getLoan],
  (loan) => loan.undoStopAccruals.pending === 'loading',
)
export const undoStopAccrualsPending = (state: RootState) => getLoan(state).undoStopAccruals.status === 'loading'

export const isDeleteConditionsLoading = createSelector([getLoan], (loan) => loan.deleteCondition.status === 'loading')
export const deleteConditionsLoading = (state: RootState) => getLoan(state).deleteCondition.status === 'loading'

export const isDeleteOfficerLoading = createSelector([getLoan], (loan) => loan.deleteOfficer.status === 'loading')
export const deleteOfficerLoading = (state: RootState) => getLoan(state).deleteOfficer.status === 'loading'

export const isDeleteAssistantLoading = createSelector([getLoan], (loan) => loan.deleteAssistant.status === 'loading')
export const deleteAssistantLoading = (state: RootState) => getLoan(state).deleteAssistant.status === 'loading'

export const isAddPermissionLoading = createSelector([getLoan], (loan) => loan.addPermission.status === 'loading')
export const addPermissionLoading = (state: RootState) => getLoan(state).addPermission.status === 'loading'

export const isDeleteTagLoading = createSelector([getLoan], (loan) => loan.loanTags.status === 'loading')
export const deleteTagLoading = (state: RootState) => getLoan(state).loanTags.status === 'loading'
